var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ranch-button',{attrs:{"icon":"plus-circle","label":_vm.label},on:{"click":_vm.showNewProjectModal}})}
var staticRenderFns = []

export { render, staticRenderFns }